/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import TicketService from '../../services/ticket';
import LoaderModal from '../../components/LoaderModal';
import {
  Container,
  Title,
  SubTitle,
  Card,
  StatusRow,
  FuncionariosButton,
} from './styles';
import { ReactComponent as PlusCredit } from '../../assets/PlusCreditOrange.svg';
import MainLoader from '../../components/MainLoader';
import { TicketOrder } from '../../interfaces/ticket';

import {
  Row,
  Column,
  InfoContainer,
  InfoItem,
  IconContainer,
} from '../../styles/components';

interface PageParams {
  id: string;
}

const CardOrderDetail: React.FC = () => {
  const { id } = useParams<PageParams>();

  const [loader, setLoader] = useState<boolean>(false);
  const [order, setOrders] = useState<TicketOrder>({} as TicketOrder);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const services = { TicketService: new TicketService() };

  const getTicketOrders = useCallback(async () => {
    try {
      setLoader(true);
      const response = await services.TicketService.getOrders({
        filters: [{ 'code-order': id }],
      });
      setOrders(response.data.ListaPedidoDeCartao[0]);

      setLoader(false);
    } catch (err) {
      console.error(err);
      setLoader(false);
    }
  }, []);
  // const getTicketBillet = useCallback(async () => {
  //   try {
  //     setLoadingModal(true);
  //     await services.TicketService.getTicketBillet(id);
  //     setLoadingModal(false);
  //   } catch (err) {
  //     const { ...error } = err;
  //     setLoadingModal(false);
  //     if (error.response.data.Summary.ErrorCollection.SystemFailureErros[0]) {
  //       addToast({
  //         type: 'error',
  //         title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
  //         description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
  //       });
  //     }
  //   }
  // }, []);

  const getStatusText = useCallback((status: any) => {
    const statusOptions: any = {
      C: 'Pronto para retirada na Central',
      F: 'Finalizado',
      E: 'Em Andamento',
    };
    return statusOptions[status];
  }, []);

  useEffect(() => {
    getTicketOrders();
  }, []);

  return (
    <Container>
      {loader ? (
        <MainLoader />
      ) : (
        <>
          <Row className="titleWrapper">
            <Column small="2" medium="2" large="2">
              <IconContainer align="center">
                <PlusCredit />
              </IconContainer>
            </Column>
            <Column
              small="10"
              medium="10"
              large="10"
              className="TitleContainer"
            >
              <Title>
                Pedido de Cartão
                <Link to="/pedidos-de-cartao">
                  <AiOutlineArrowLeft size={30} style={{ color: '#3F1159' }} />
                </Link>
              </Title>
              <SubTitle>{id}</SubTitle>
            </Column>
          </Row>
          <Row className="CardContainer">
            <Column small="2" medium="2" large="2">
              <InfoContainer>
                <InfoItem>
                  <span className="info">&#9432;</span>
                  Regras de cancelamento
                </InfoItem>
              </InfoContainer>
            </Column>
            <Column small="10" medium="10" large="10">
              <Card>
                <div className="Container">
                  <Row>
                    <Column small="6" medium="6" large="6">
                      <div className="title">Código do Pedido</div>
                      <div className="codeText">{id}</div>
                    </Column>
                    <Column small="6" medium="6" large="6">
                      <div className="title">Quantidade de Cartões</div>
                      <div className="text">{order.QuantidadeCartoes}</div>
                    </Column>
                    <Column small="6" medium="6" large="6">
                      <div className="title">Data do Pedido</div>
                      <div className="text">{order.DataPedido}</div>
                    </Column>
                    <Column small="6" medium="6" large="6">
                      <div className="title">
                        Quantidade de Funcionários Atendidos
                      </div>
                      <div className="text">
                        {order.ListaDadosDeFuncionarioQuantidade}
                      </div>
                    </Column>
                    <Column small="6" medium="6" large="6">
                      <div className="title">Status</div>
                      <div className="text">
                        {order.StatusPedido && (
                          <StatusRow
                            status={
                              order.StatusPedido === 'C'
                                ? 'C'
                                : order.StatusPedido === 'F'
                                ? 'F'
                                : order.StatusPedido === 'E'
                                ? 'E'
                                : 'C'
                            }
                          >
                            {getStatusText(order.StatusPedido)}
                          </StatusRow>
                        )}
                      </div>
                    </Column>
                    <Column small="6" medium="6" large="6">
                      <div className="title">Funcionários Atendidos</div>
                      <div className="text">
                        {order.ListaDadosDeFuncionarioQuantidade < 1 ? (
                          <div>Nenhum Funcionário atendido</div>
                        ) : (
                          <FuncionariosButton>
                            VER FUNCIONARIOS
                          </FuncionariosButton>
                        )}
                      </div>
                    </Column>
                  </Row>
                </div>
              </Card>
            </Column>
          </Row>
          {/* <Row className="CardContainer">
            <Column small="2" medium="2" large="2">
              <InfoContainer />
            </Column>
            <Column small="10" medium="10" large="10">
              <Card>
                {order.DadosDeCobrancaBoletoPedido && (
                  <div className="Container">
                    <Row>
                      <Column small="12" medium="12" large="12">
                        <div className="boletoTitle">
                          <MdReceipt />
                          Boleto
                        </div>
                      </Column>
                      <Column small="6" medium="6" large="6">
                        <div className="title">Tipo de Serviço</div>
                        <div className="text">Boleto</div>
                      </Column>
                      <Column small="6" medium="6" large="6">
                        <div className="title">Data do Vencimento</div>
                        <div className="text">
                          {order.DadosDeCobrancaBoletoPedido.DataVencimento}
                        </div>
                      </Column>
                      <Column small="6" medium="6" large="6">
                        <div className="title">Valor do Boleto</div>
                        <div className="text">
                          {formatPrice(
                            order.DadosDeCobrancaBoletoPedido.ValorBoleto,
                          )}
                        </div>
                      </Column>
                      <Column small="6" medium="6" large="6">
                        <div className="title">Data do Pagamento</div>
                        <div className="text">
                          {order.DadosDeCobrancaBoletoPedido.DataPagamento}
                        </div>
                      </Column>
                      <Column small="6" medium="6" large="6">
                        <div className="title">Valor Cobrado</div>
                        <div className="text">
                          {formatPrice(
                            order.DadosDeCobrancaBoletoPedido.ValorCobrado,
                          )}
                        </div>
                      </Column>
                      <Column small="6" medium="6" large="6">
                        <div className="title">Data de Cancelamento</div>
                        <div className="text">
                          {order.DadosDeCobrancaBoletoPedido.DataCancelamento}
                        </div>
                      </Column>
                      <Column small="6" medium="6" large="6">
                        <div className="title">Status</div>
                        <div className="text">{id}</div>
                      </Column>
                      <Column small="6" medium="6" large="6">
                        <div className="title">Emitir Boleto</div>
                        <div className="text">
                          <BoletoButton onClick={getTicketBillet}>
                            <MdReceipt />
                            Emitir Boleto
                          </BoletoButton>
                        </div>
                      </Column>
                    </Row>
                  </div>
                )}
              </Card>
            </Column>
          </Row> */}
        </>
      )}
      {loadingModal && (
        <LoaderModal
          title="Carregando"
          show={loadingModal}
          handleClose={() => setLoadingModal(false)}
        />
      )}
    </Container>
  );
};

export default CardOrderDetail;
